export const path = "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM8.04993 11H12.624V13H4.62402V5H6.62402V9.37207L11.4727 4.52338L12.9996 6.05029L8.04993 11Z"
